<ion-buttons *ngIf="online$ | async; let online">
  <ion-icon
    size="large"
    [name]="online === 'online' ? 'cloud-done-outline' : 'cloud-offline-outline'"
    [color]="online === 'online' ? 'success' : 'warning'"
    [title]="online === 'online' ? 'Online' : 'Offline'"
  >
  </ion-icon>
</ion-buttons>

<ion-icon name="add" class="hidden"></ion-icon>
<ion-icon name="alert-circle-outline" class="hidden"></ion-icon>
<ion-icon name="arrow-back-outline" class="hidden"></ion-icon>
<ion-icon name="arrow-back-circle-outline" class="hidden"></ion-icon>
<ion-icon name="arrow-forward-circle-outline" class="hidden"></ion-icon>
<ion-icon name="arrow-undo-circle-outline" class="hidden"></ion-icon>
<ion-icon name="checkmark" class="hidden"></ion-icon>
<ion-icon name="checkmark-outline" class="hidden"></ion-icon>
<ion-icon name="checkmark-circle-outline" class="hidden"></ion-icon>
<ion-icon name="chevron-back" class="hidden"></ion-icon>
<ion-icon name="chevron-down-outline" class="hidden"></ion-icon>
<ion-icon name="chevron-forward" class="hidden"></ion-icon>
<ion-icon name="chevron-forward-outline" class="hidden"></ion-icon>
<ion-icon name="close-circle-outline" class="hidden"></ion-icon>
<ion-icon name="cloud-done-outline" class="hidden"></ion-icon>
<ion-icon name="cloud-download-outline" class="hidden"></ion-icon>
<ion-icon name="cloud-offline-outline" class="hidden"></ion-icon>
<ion-icon name="cloud-upload-outline" class="hidden"></ion-icon>
<ion-icon name="enter-outline" class="hidden"></ion-icon>
<ion-icon name="ellipsis-vertical" class="hidden"></ion-icon>
<ion-icon name="hourglass" class="hidden"></ion-icon>
<ion-icon name="information-circle-outline" class="hidden"></ion-icon>
<ion-icon name="lock-closed-outline" class="hidden"></ion-icon>
<ion-icon name="lock-open-outline" class="hidden"></ion-icon>
<ion-icon name="log-out-sharp" class="hidden"></ion-icon>
<ion-icon name="megaphone" class="hidden"></ion-icon>
<ion-icon name="menu-sharp" class="hidden"></ion-icon>
<ion-icon name="person-add-outline" class="hidden"></ion-icon>
<ion-icon name="person-remove-outline" class="hidden"></ion-icon>
<ion-icon name="save-outline" class="hidden"></ion-icon>
<ion-icon name="server-outline" class="hidden"></ion-icon>
<ion-icon name="settings" class="hidden"></ion-icon>
<ion-icon name="time" class="hidden"></ion-icon>
<ion-icon name="timer" class="hidden"></ion-icon>
